import orgamax from 'ampersand-app'
import Decimal from 'decimal.js'
import { isNil } from 'lodash'
import { getAppState } from '@/redux/store'

const calculatePositionBasedGross = (totalGross, vatPercent) => {
  const vatPercentCalc = new Decimal(vatPercent || 0).div(100).plus(1)
  const totalGrossCalc = totalGross ? new Decimal(totalGross) : new Decimal(0)
  const totalNet = totalGrossCalc.div(vatPercentCalc)
  const vat = totalGrossCalc.minus(totalNet)

  return {
    totalGross: totalGrossCalc.toDP(2).toNumber(),
    totalNet: totalNet.toDP(2).toNumber(),
    vatPercent,
    vat: vat.toDP(2).toNumber(),
  }
}

const calculatePositionBasedNet = (totalNet, vatPercent) => {
  const vatPercentCalc = new Decimal(vatPercent || 0).div(100).plus(1)
  const totalGrossCalc = totalNet ? Decimal(totalNet).times(vatPercentCalc) : new Decimal(0)
  totalNet = Decimal(totalNet || 0)
  const vat = totalGrossCalc.minus(totalNet)

  return {
    totalGross: totalGrossCalc.toDP(2).toNumber(),
    totalNet: totalNet.toDP(2).toNumber(),
    vatPercent,
    vat: vat.toDP(2).toNumber(),
  }
}

export { calculatePositionBasedGross, calculatePositionBasedNet }

const PositionWithTaxCategory = (props = {}) => {
  const {
    totalGross,
    totalNet,
    vatPercent,
    dateFor,
  } = props
  let defaultVatValue = 0
  if (isNil(vatPercent) && orgamax.user) {
    // Check if company is VAT-exempt (has defaultRevenueAccount)
    const companyData = getAppState()?.settings?.company
    const isVatExempt = companyData?.defaultRevenueAccount !== null && companyData?.defaultRevenueAccount !== ''

    if (isVatExempt) {
      defaultVatValue = 0
    } else {
      defaultVatValue = orgamax.user.getDefaultVatByDate(dateFor).value
    }
  }
  const result = totalGross
    ? calculatePositionBasedGross(totalGross, vatPercent || defaultVatValue)
    : calculatePositionBasedNet(totalNet, vatPercent || defaultVatValue)
  return result
}

export default PositionWithTaxCategory
